function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/converters/tableproperites
 */

/**
 * Conversion helper for upcasting attributes using normalized styles.
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {Object} options
 * @param {String} options.modelAttribute The attribute to set.
 * @param {String} options.styleName The style name to convert.
 * @param {String} options.viewElement The view element name that should be converted.
 * @param {String} options.defaultValue The default value for the specified `modelAttribute`.
 * @param {Boolean} [options.reduceBoxSides=false]
 */
export function upcastStyleToAttribute(conversion, options) {
  var viewElement = options.viewElement,
      defaultValue = options.defaultValue,
      modelAttribute = options.modelAttribute,
      styleName = options.styleName,
      _options$reduceBoxSid = options.reduceBoxSides,
      reduceBoxSides = _options$reduceBoxSid === void 0 ? false : _options$reduceBoxSid;
  conversion.for('upcast').attributeToAttribute({
    view: {
      name: viewElement,
      styles: _defineProperty({}, styleName, /[\s\S]+/)
    },
    model: {
      key: modelAttribute,
      value: function value(viewElement) {
        var normalized = viewElement.getNormalizedStyle(styleName);
        var value = reduceBoxSides ? reduceBoxSidesValue(normalized) : normalized;

        if (defaultValue !== value) {
          return value;
        }
      }
    }
  });
}
/**
 * Conversion helper for upcasting border styles for view elements.
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {String} viewElementName
 * @param {Object} defaultBorder The default border values.
 * @param {String} defaultBorder.color The default `borderColor` value.
 * @param {String} defaultBorder.style The default `borderStyle` value.
 * @param {String} defaultBorder.width The default `borderWidth` value.
 */

export function upcastBorderStyles(conversion, viewElementName, defaultBorder) {
  conversion.for('upcast').add(function (dispatcher) {
    return dispatcher.on('element:' + viewElementName, function (evt, data, conversionApi) {
      // If the element was not converted by element-to-element converter,
      // we should not try to convert the style. See #8393.
      if (!data.modelRange) {
        return;
      } // Check the most detailed properties. These will be always set directly or
      // when using the "group" properties like: `border-(top|right|bottom|left)` or `border`.


      var stylesToConsume = ['border-top-width', 'border-top-color', 'border-top-style', 'border-bottom-width', 'border-bottom-color', 'border-bottom-style', 'border-right-width', 'border-right-color', 'border-right-style', 'border-left-width', 'border-left-color', 'border-left-style'].filter(function (styleName) {
        return data.viewItem.hasStyle(styleName);
      });

      if (!stylesToConsume.length) {
        return;
      }

      var matcherPattern = {
        styles: stylesToConsume
      }; // Try to consume appropriate values from consumable values list.

      if (!conversionApi.consumable.test(data.viewItem, matcherPattern)) {
        return;
      }

      var modelElement = _toConsumableArray(data.modelRange.getItems({
        shallow: true
      })).pop();

      conversionApi.consumable.consume(data.viewItem, matcherPattern);
      var normalizedBorder = {
        style: data.viewItem.getNormalizedStyle('border-style'),
        color: data.viewItem.getNormalizedStyle('border-color'),
        width: data.viewItem.getNormalizedStyle('border-width')
      };
      var reducedBorder = {
        style: reduceBoxSidesValue(normalizedBorder.style),
        color: reduceBoxSidesValue(normalizedBorder.color),
        width: reduceBoxSidesValue(normalizedBorder.width)
      };

      if (reducedBorder.style !== defaultBorder.style) {
        conversionApi.writer.setAttribute('borderStyle', reducedBorder.style, modelElement);
      }

      if (reducedBorder.color !== defaultBorder.color) {
        conversionApi.writer.setAttribute('borderColor', reducedBorder.color, modelElement);
      }

      if (reducedBorder.width !== defaultBorder.width) {
        conversionApi.writer.setAttribute('borderWidth', reducedBorder.width, modelElement);
      }
    });
  });
}
/**
 * Conversion helper for downcasting an attribute to a style.
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {Object} options
 * @param {String} options.modelElement
 * @param {String} options.modelAttribute
 * @param {String} options.styleName
 */

export function downcastAttributeToStyle(conversion, _ref) {
  var modelElement = _ref.modelElement,
      modelAttribute = _ref.modelAttribute,
      styleName = _ref.styleName;
  conversion.for('downcast').attributeToAttribute({
    model: {
      name: modelElement,
      key: modelAttribute
    },
    view: function view(modelAttributeValue) {
      return {
        key: 'style',
        value: _defineProperty({}, styleName, modelAttributeValue)
      };
    }
  });
}
/**
 * Conversion helper for downcasting attributes from the model table to a view table (not to `<figure>`).
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {Object} options
 * @param {String} options.modelAttribute
 * @param {String} options.styleName
 */

export function downcastTableAttribute(conversion, _ref2) {
  var modelAttribute = _ref2.modelAttribute,
      styleName = _ref2.styleName;
  conversion.for('downcast').add(function (dispatcher) {
    return dispatcher.on("attribute:".concat(modelAttribute, ":table"), function (evt, data, conversionApi) {
      var item = data.item,
          attributeNewValue = data.attributeNewValue;
      var mapper = conversionApi.mapper,
          writer = conversionApi.writer;

      if (!conversionApi.consumable.consume(data.item, evt.name)) {
        return;
      }

      var table = _toConsumableArray(mapper.toViewElement(item).getChildren()).find(function (child) {
        return child.is('element', 'table');
      });

      if (attributeNewValue) {
        writer.setStyle(styleName, attributeNewValue, table);
      } else {
        writer.removeStyle(styleName, table);
      }
    });
  });
} // Reduces the full top, right, bottom, left object to a single string if all sides are equal.

function reduceBoxSidesValue(style) {
  if (!style) {
    return;
  }

  var commonValue = ['top', 'right', 'bottom', 'left'].map(function (side) {
    return style[side];
  }).reduce(function (result, side) {
    return result == side ? result : null;
  });
  return commonValue || style;
}